export const buildMarketingMetaAdsFilterGroups = (venueOwnerships = [], filterOptions = {}) => {
  const groups = [];

  if (venueOwnerships && venueOwnerships.length > 0) {
    groups.push({
      label: 'Venues',
      filters: [{
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: venueOwnerships.map((vo) => ({
          value: String(vo.id),
          label: vo.name || vo.venue_name || `Venue ${vo.id}`,
        })),
      }],
    });
  }

  const eventFilters = [];
  if (filterOptions.event_options && filterOptions.event_options.length > 0) {
    eventFilters.push({
      id: 'event_name',
      label: 'Event Name',
      type: 'checkbox',
      options: filterOptions.event_options.map((name) => ({ value: name, label: name })),
    });
  }
  if (filterOptions.status_options && filterOptions.status_options.length > 0) {
    eventFilters.push({
      id: 'event_status',
      label: 'Status',
      type: 'checkbox',
      options: filterOptions.status_options,
    });
  }
  if (eventFilters.length > 0) {
    groups.push({ label: 'Events', filters: eventFilters });
  }

  return groups;
};
